const GRID_COLS = 25;
const GRID_ROWS = 20;
const GAP = 16;
const CITY_WIDTH = 80 * (50 / 35);
const CITY_HEIGHT = 80;
const CELL_WIDTH = CITY_WIDTH + GAP;
const CELL_HEIGHT = CITY_HEIGHT + GAP;

const UPGRADE_ORDER = [
  'None',
  'Basic',
  'Island',
  'Ocean',
  'Jungle',
  'Arctic',
  'Wasteland',
  'Monsters',
  'Biodome',
  'Space Station',
  'Acid Overload',
];

function groupCitiesByUpgrade(cities) {
  const groups = {};

  UPGRADE_ORDER.forEach((upgrade) => {
    groups[upgrade] = [];
  });

  cities.forEach((city) => {
    const upgrade = city.metadata?.properties?.Upgrade || 'None';
    const normalizedUpgrade = UPGRADE_ORDER.includes(upgrade) ? upgrade : 'None';
    groups[normalizedUpgrade].push(city);
  });

  return groups;
}

export function calculateCityPositions(cities) {
  if (!cities || cities.length === 0) return { positions: [], clusters: [] };

  const groups = groupCitiesByUpgrade(cities);
  const positions = [];
  const clusters = [];

  const totalWidth = GRID_COLS * CELL_WIDTH;
  const totalHeight = GRID_ROWS * CELL_HEIGHT;
  const offsetX = -totalWidth / 2 + CELL_WIDTH / 2;
  const offsetY = totalHeight / 2 - CELL_HEIGHT / 2;

  let currentIndex = 0;

  UPGRADE_ORDER.forEach((upgradeName) => {
    const citiesInGroup = groups[upgradeName];
    if (citiesInGroup.length === 0) return;

    const startIndex = currentIndex;
    const startRow = Math.floor(startIndex / GRID_COLS);
    const startCol = startIndex % GRID_COLS;

    clusters.push({
      name: upgradeName,
      x: offsetX + startCol * CELL_WIDTH,
      y: offsetY - startRow * CELL_HEIGHT + 60,
      count: citiesInGroup.length,
    });

    citiesInGroup.forEach((city) => {
      const row = Math.floor(currentIndex / GRID_COLS);
      const col = currentIndex % GRID_COLS;

      const x = offsetX + col * CELL_WIDTH;
      const y = offsetY - row * CELL_HEIGHT;

      positions.push({
        cityIndex: city.index,
        x,
        y,
        z: 0,
        upgrade: upgradeName,
      });

      currentIndex++;
    });
  });

  return { positions, clusters };
}

export function getCitySize() {
  return {
    width: 80 * (50 / 35),
    height: 80,
  };
}

export function getWorldBounds(positions) {
  if (positions.length === 0) {
    return { minX: -1000, maxX: 1000, minY: -1000, maxY: 1000 };
  }

  return positions.reduce(
    (bounds, pos) => ({
      minX: Math.min(bounds.minX, pos.x),
      maxX: Math.max(bounds.maxX, pos.x),
      minY: Math.min(bounds.minY, pos.y),
      maxY: Math.max(bounds.maxY, pos.y),
    }),
    { minX: Infinity, maxX: -Infinity, minY: Infinity, maxY: -Infinity }
  );
}
